import useReactHookFormProps from '../../../hooks/useReactHookFormProps';
import useIntl from '../../../hooks/useIntl';
import messages from './messages';
import { useMemo, useState } from 'react';

const useFormProps = ({
  updateRentForecast,
  initialValues,
  editState,
  setEditState,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const intl = useIntl();
  const ReactHookFormProps = useReactHookFormProps({
    mode: 'onChange',
    defaultValues: {
      transmissionDate: null,
      transmissionNumber: null,
    },
    values: initialValues,
  });
  const onValid = async () => {
    const values = ReactHookFormProps.getValues();

    // Clean and adapt to null if empty
    values.transmissionNumber = values.transmissionNumber?.trim() || null;

    setEditState(true);
    setSubmitting(true);
    await updateRentForecast(values, {
      onSuccess: () => {
        setEditState(false);
        ReactHookFormProps.reset(values);
      },
      onSettled: () => {
        setSubmitting(false);
      },
    });
  };

  const onSubmit = ReactHookFormProps.handleSubmit(onValid);

  const reset = () => {
    ReactHookFormProps.reset();
  };

  const fields = useMemo(
    () => [
      {
        label: intl.formatMessage(messages.transmissionDateLabel),
        name: 'transmissionDate',
        variant: 'date',
        readOnly: !editState,
        disabled: submitting,
        helperText: null,
      },
      {
        label: intl.formatMessage(messages.transmissionNumberLabel),
        name: 'transmissionNumber',
        variant: 'text',
        helperText: null,
        readOnly: !editState,
        disabled: submitting,
        inputProps: { maxLength: 50 },
        ...(!editState
          ? {
              // Make --- display only when readonly, gives visibility that there is no value when empty
              placeholder: '---',
              sx: {
                '& .MuiOutlinedInput-input::placeholder': {
                  color: 'black',
                  opacity: 1,
                },
              },
            }
          : {}),
        multiline: true,
      },
    ],
    [submitting, editState, initialValues],
  );

  return {
    fields,
    ReactHookFormProps,
    onSubmit,
    submitting,
    reset,
  };
};

export default useFormProps;
